import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { readerApi } from '../services/api';
import './Layout.css';

const Layout = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [primaryReader, setPrimaryReader] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      loadPrimaryReader();
    }
  }, [isAuthenticated]);

  const loadPrimaryReader = async () => {
    try {
      const response = await readerApi.getReaders();
      const primary = response.data.readers?.find(r => r.isPrimary);
      setPrimaryReader(primary);
    } catch (error) {
      console.error('Failed to load primary reader:', error);
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Check if user has a church for CSS class
  const hasChurch = isAuthenticated && user?.church;

  return (
    <div className={`layout ${hasChurch ? 'has-church' : 'no-church'}`}>
      <Header onMenuClick={toggleSidebar} primaryReader={primaryReader} />
      
      <main className="main-content">
        {children}
      </main>
      
      <Footer />
      
      {isAuthenticated && (
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={closeSidebar}
        />
      )}
      
      {/* Overlay for sidebar */}
      {sidebarOpen && isAuthenticated && (
        <div 
          className="sidebar-overlay" 
          onClick={closeSidebar}
        />
      )}
    </div>
  );
};

export default Layout;
